import { render } from "./AdditionalIndex.vue?vue&type=template&id=3c613f31"
import script from "./AdditionalIndex.vue?vue&type=script&lang=js"
export * from "./AdditionalIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__